/**
 * Timezone utilities for the application
 */
import { formatInTimeZone, toZonedTime } from 'date-fns-tz';

// Get all available timezones from the Intl API
export const getAvailableTimezones = (): string[] => {
    try {
        return Intl.supportedValuesOf('timeZone');
    } catch (error) {
        console.error('Error getting available timezones:', error);
        // Fallback for browsers that don't support Intl.supportedValuesOf
        return [
            'UTC',
            'America/New_York',
            'America/Chicago',
            'America/Denver',
            'America/Los_Angeles',
            'Europe/London',
            'Europe/Paris',
            'Asia/Tokyo',
            'Australia/Sydney',
        ];
    }
};

// Get the user's current timezone
export const getUserTimezone = (): string => {
    try {
        return Intl.DateTimeFormat().resolvedOptions().timeZone;
    } catch (error) {
        console.error('Error getting user timezone:', error);
        return 'UTC';
    }
};

// Format a date with a specific timezone
export const formatDateWithTimezone = (
    date: Date,
    timezone: string
): string => {
    return formatInTimeZone(date, timezone, 'PPpp');
};

// Parse a date and time string with timezone consideration
export const parseDateTime = (
    date: Date,
    timeString: string,
    timezone: string
): Date => {
    const [hours, minutes] = timeString.split(':').map(Number);

    // Create a new date object with the same date
    const localDate = new Date(date);
    localDate.setHours(hours, minutes, 0, 0);

    // Convert the local date to the specified timezone
    return toZonedTime(localDate, timezone);
};
